import type {ReactNode} from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import {Layout} from '@components/Layout';
import {Button, Spinner} from '@goproblems/ui';
import '../../styles/dashboard.scss';
import '../../styles/tournament.scss';

export const TournamentPage = ({
    children,
    className = '',
}: {
    children: ReactNode;
    className?: string;
}) => (
    <Layout containerClassName={`dashboard-page tournaments-page ${className}`}>
        <div className="dashboard-content">{children}</div>
    </Layout>
);

export type TournamentBackLink = {to: string; label: string};

export const TournamentTitle = ({
    children,
    back,
}: {
    children: ReactNode;
    back?: TournamentBackLink;
}) => {
    const {t} = useTranslation();
    const destination = back ?? {
        to: '/tournaments',
        label: t('tournaments.tournaments'),
    };
    return (
        <div className="tournament-title">
            <Link
                to={destination.to}
                className="tournament-back"
                aria-label={destination.label}
                title={destination.label}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </Link>
            <h1>{children}</h1>
        </div>
    );
};

export const TournamentState = ({
    error = false,
    retry,
}: {
    error?: boolean;
    retry?: () => unknown;
}) => {
    const {t} = useTranslation();
    return (
        <div className="tournament-state" role={error ? 'alert' : 'status'}>
            {!error && <Spinner size="sm" />}
            <span>{t(error ? 'common.error' : 'common.loading')}</span>
            {error && retry && (
                <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => void retry()}>
                    {t('problem_browser.retry')}
                </Button>
            )}
        </div>
    );
};
